import React from 'react'
import Image from '../../UIComponent/Image'
import './BannerWithContent.scss'

export default function BannerWithContent(props) {
  return (
    <div className="rhs-global-banner-template">
      <div className="image">
        <picture>
          <source media="(max-width:991px)" srcset={props.mobimagepath} />
          <Image imageSrc={props.imagepath} imageClass="w-100"></Image>
        </picture>
        {/* <Image imageSrc={props.imagepath} imageClass="w-100"></Image> */}
      </div>
      <div
        className="content"
        dangerouslySetInnerHTML={{ __html: props.bannerContent }}
      ></div>
    </div>
  )
}
